// extracted by mini-css-extract-plugin
module.exports = {"pagination":"ImportInvoicesPagination_pagination__2g3Wp","button":"ImportInvoicesPagination_button__25UjG","boxSpinner":"ImportInvoicesPagination_boxSpinner__2CTWu"};